/* =============================================
   LUARARTS — Esports Motion Layer JS (global)
   Scroll-reveal: sections/grids snap in as they
   enter the viewport. Additive; safe everywhere.
   ============================================= */

(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const targets = [
    '.la-home-type-block',
    '.la-home-product-grid',
    '.la-co-card',
    '.la-co-addon-card',
    '.la-co-order-form',
    '.lp-related-card'
  ];

  function init() {
    const els = document.querySelectorAll(targets.join(','));
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-revealed'));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach((el) => {
      el.classList.add('la-reveal');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
